"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    card: {
      width: "100%",
      borderRadius: theme.spacing(1),
      border: "1px solid ".concat(theme.palette.divider)
    }
  };
});
var Card = function Card(_ref) {
  var height = _ref.height,
    children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Card, {
    elevation: 0,
    className: classes.card,
    sx: {
      height: height
    },
    children: children
  });
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Card);